/**
 * Забирает с DOM-элемента нужные стили.
 * Если передан пропс onlyNumbers === true - оставляет только число
 *
 * Пример:
 * getStyle(this.node, 'margin-bottom', true)
 *
 * @param element
 * @param styleName
 * @param onlyNumbers
 * @returns {*}
 */
export default function (element, styleName, onlyNumbers = false) {
  let styleValue = '';

  if (document.defaultView && document.defaultView.getComputedStyle) {
    styleValue = document.defaultView.getComputedStyle(element, '').getPropertyValue(styleName);
  } else if (element.currentStyle) {
    const clearedName = styleName.replace(/-(\w)/g, (strMatch, p1) => p1.toUpperCase());
    styleValue = element.currentStyle[clearedName];
  }

  if (onlyNumbers) {
    const parsedStyle = parseInt(styleValue, 10);
    if (isNaN(parsedStyle)) return 0;
    return parsedStyle;
  }

  return styleValue;
}
